"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SliderInput = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var helios_forms_1 = require("@carvana/helios-forms");
var helios_styles_1 = require("@carvana/helios-styles");
var react_1 = require("react");
var styled_components_1 = __importDefault(require("styled-components"));
var useDebounce_1 = require("./useDebounce");
var Input = (0, styled_components_1.default)(helios_forms_1.TextInput)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  width: 104px;\n\n  input {\n    text-align: center;\n    padding: 10px;\n    height: unset;\n    ", "\n  }\n\n  &.is-populated {\n    svg {\n      display: none;\n    }\n  }\n"], ["\n  width: 104px;\n\n  input {\n    text-align: center;\n    padding: 10px;\n    height: unset;\n    ", "\n  }\n\n  &.is-populated {\n    svg {\n      display: none;\n    }\n  }\n"])), helios_styles_1.label.lg);
var SliderInput = function (_a) {
    var value = _a.value, id = _a.id, onChange = _a.onChange, disabled = _a.disabled, delay = _a.delay;
    var _b = (0, react_1.useState)(null), inputValue = _b[0], setInputValue = _b[1];
    var debounce = (0, useDebounce_1.useDebounce)(delay);
    return ((0, jsx_runtime_1.jsx)(Input, { id: id, testId: id, className: "slider-input", type: "text", value: inputValue || value, onChange: function (e) {
            var nextValue = e.target.value;
            setInputValue(nextValue);
            debounce(function () {
                onChange(nextValue);
                setInputValue(null);
            });
        }, disabled: disabled, onFocus: function (e) { return e.target.select(); }, onBlur: function (e) {
            var nextValue = e.target.value;
            onChange(nextValue);
        } }));
};
exports.SliderInput = SliderInput;
var templateObject_1;
